import { LoginForm } from "../login";
import { RegisterForm } from "../register";
import { OnboardingForm } from "../onboarding";
import { ResetPasswordForm } from "../resetPassword";
import { NoCompanyForm } from "../noCompany";
import { Verified, VerifyForm } from "../verify";
import { InviteAcceptForm } from "../invite";
import { CompleteProfileForm } from "../completeProfile";
import { AuthPage } from "./types";
import { AuthInnerRoutes } from "../types";

export const routeData: Record<
  AuthInnerRoutes,
  { pageType: AuthPage; component: JSX.Element }
> = {
  signin: {
    pageType: "signin",
    component: <LoginForm />,
  },
  register: {
    pageType: "register",
    component: <RegisterForm />,
  },
  onboarding: {
    pageType: "onboarding",
    component: <OnboardingForm />,
  },
  resetPassword: {
    pageType: "reset",
    component: <ResetPasswordForm />,
  },
  noCompany: {
    pageType: "nocompany",
    component: <NoCompanyForm />,
  },
  verify: {
    pageType: "nocompany",
    component: <VerifyForm />,
  },
  "email-verified": {
    pageType: "nocompany",
    component: <Verified />,
  },
  "accept-invite": {
    pageType: "invite",
    component: <InviteAcceptForm />,
  },
  "complete-profile": {
    pageType: "completeProfile",
    component: <CompleteProfileForm />,
  },
};
